import http from "../../helpers/http";
import { doObjToFormData } from "../../helpers/helpers";

import {
  FETCH_BLOG_DETAIL_CONTENT_SUCCESS,
  FETCH_BLOG_DETAIL_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = (id) => (dispatch) => {
  http
    .post("blog-detail", doObjToFormData({ id: id }))
    .then(({ data }) => {
      dispatch({
        type: FETCH_BLOG_DETAIL_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_BLOG_DETAIL_CONTENT_FAILED,
        payload: error
      });
    });
};
